<template>
    <div class="c-result-stat-correctness">
        <div class="wr-result-stat-correctness-content">
            <span class="c-result-stat-correctness__mode-label">PRATİK MODU</span>
            <span class="c-result-stat-correctness__mode-name">{{ $t(modeName) }}</span>
            <span class="c-result-stat-correctness__stat-percent">{{indicatorPercent}}%</span>
            <span class="c-result-stat-correctness__stat-label">DOĞRULUK</span>
            <div class="c-result-stat-correctnessbar">
                <span class="c-result-stat-correctnessbar__indicator"
                    :style="indicatorStyle"></span>
            </div>
        </div>
        <svg class="deco-result-stat-correctness-light" width="251" height="283" viewBox="0 0 251 283" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M58 0L0 283h251L189 0H58z" fill="url(#prefix__paint0_linear_110_7013)"/><defs><linearGradient id="prefix__paint0_linear_110_7013" x1="125.5" y1="283" x2="125.5" y2="0" gradientUnits="userSpaceOnUse"><stop stop-color="#D9D9D9" stop-opacity=".62"/><stop offset="1" stop-color="#D9D9D9" stop-opacity="0"/></linearGradient></defs></svg>
        <svg class="deco-result-stat-correctness-polycircle" width="67" height="172" viewBox="0 0 67 172" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="22.422" cy="22.422" r="22.422" transform="matrix(-1 0 0 1 11.437 43.211)" fill="#1A4684" fill-opacity=".5"/><circle cx="2.981" cy="149.108" r="10.09" fill="#00DEFF" fill-opacity=".75"/><path d="M60.568 80.565L23.055 70.513l10.051 37.514 27.462-27.462z" fill="#00DEFF" fill-opacity=".75"/><path d="M29.688 179.735l-37.513-10.051 10.052 37.513 27.461-27.462z" fill="#3D2080" fill-opacity=".75"/></svg>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            indicatorPercent: { type: Number, default: 33 },
        },

        computed: {
            modeName(){
                if(!this.$store.state.practiceSession){
                    return 'lorem_mode';
                }

                return this.$store.state.practiceSession.type;
            },
            
            indicatorStyle(){
                let correctnessbarWidth = 128;
                let indicatorWidth = (correctnessbarWidth / 100) * this.indicatorPercent;
                return `width: ${indicatorWidth}px;`;
            }
        }
    };
</script>

<style scoped src="@/css/components/c-result-stat-correctness.css"></style>